import { render, staticRenderFns } from "./paynotify.vue?vue&type=template&id=2b4960a7"
import script from "./paynotify.vue?vue&type=script&lang=js"
export * from "./paynotify.vue?vue&type=script&lang=js"
import style0 from "./paynotify.vue?vue&type=style&index=0&id=2b4960a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports